import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './lib/auth.tsx';
import { App } from './App.tsx';
import { registerServiceWorker } from './lib/push.ts';
import './index.css';

// After load, so the worker's (empty) fetch handler never sits in front of the
// first paint. Production only — see registerServiceWorker.
window.addEventListener('load', () => {
  void registerServiceWorker();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
